import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, Copyright } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="disclaimer-section">
          <div className="disclaimer-card">
            <AlertTriangle size={24} color="#ffc107" />
            <div className="disclaimer-text">
              <h3>Important Disclaimer</h3>
              <p>
                All scripts, articles, and information provided on MSSQLDBATeam.com are for educational 
                and informational purposes only. While we strive for accuracy and test our content in 
                production environments, we are not responsible for any damages, data loss, or issues 
                that may arise from using this content.
              </p>
              <p>
                <strong>Always test scripts in a development environment before using in production.</strong> 
                Users are solely responsible for understanding and validating any code or procedures 
                before implementation in their environments.
              </p>
            </div>
          </div>
        </div>

        <div className="footer-links">
          <div className="footer-section">
            <h4>Resources</h4>
            <ul>
              <li><Link to="/performance">Performance</Link></li>
              <li><Link to="/security">Security</Link></li>
              <li><Link to="/high-availability">High Availability</Link></li>
              <li><Link to="/backup-recovery">Backup & Recovery</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>More Categories</h4>
            <ul>
              <li><Link to="/automation">Automation</Link></li>
              <li><Link to="/installation">Installation</Link></li>
              <li><Link to="/architecture">Architecture</Link></li>
              <li><Link to="/maintenance">Miscellaneous</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>About</h4>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/authors">Our Authors</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">
            <Copyright size={16} />
            <span>{currentYear} MSSQLDBATeam.com. All rights reserved.</span>
          </div>
          <div className="footer-tagline">
            <p>Empowering SQL Server DBAs with production-ready solutions.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;